// extracted by mini-css-extract-plugin
module.exports = {"guidePage":"GuidePage_guidePage__T3tXB","content":"GuidePage_content__yUsPA"};